export const individualMapping = {
  if: `If`,
  apply_conditions: `Apply Conditions`,
  add_another_condition: `Add Another Condition`,
  field_name: `Field Name`,
  select_field: `Select Field`,
  is: `Is`,
  select_operator: `Select Operator`,
  enter_value_condition: `Enter Value`,
  and: `AND`,
  map_values: `Map Values`,
  add_another_mapping: `Add Another Mapping`,
  set: `Set`,
  target_field: `Target Field`,
  select_target_field: `Select Target Field`,
  direct_value: `Direct Value`,
  field_value_type: `Field`,
  formula_value_type: `Formula`,
  insert_a_field: `Insert A Field`,
  formula_operator_add: `Add`,
  formula_operator_subtract: `Subtract`,
  formula_operator_multiply: `Multiply`,
  formula_operator_divide: `Divide`,
};
